import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@pwc/appkit-react/lib/Input';

import { InputSizes } from '../constants';
import { FormikPropTypes } from '../propTypes';

const InputFormik = ({
  className = '',
  type = 'text',
  size = InputSizes.SM,
  label = '',
  disabled = false,
  formik,
  name,
  value,
  valueFormatter,
  handleExternalChange = false,
  hidden = false,
  ...restProps
}) => {
  const errorMessage = formik.errors[name];
  const fieldTouched = formik.touched[name];
  const shouldDisplayError = errorMessage && fieldTouched;

  const handleBlur = useCallback(() => {
    formik.setTouched({
      ...formik.touched,
      [name]: true,
    });
    formik.setFieldValue(name, valueFormatter ? valueFormatter(value) : value);
  }, [name, formik, value, valueFormatter]);

  const handleChange = useCallback(value => {
    formik.setFieldValue(name, value);
  }, [name, formik]);

  useEffect(() => {
    if (handleExternalChange) {
      formik.setFieldValue(name, value);
    }
  }, [name, value, handleExternalChange]); // eslint-disable-line react-hooks/exhaustive-deps

  return hidden ? null : (
    <Input
      className={className}
      type={type}
      size={size}
      label={label}
      name={name}
      value={value || ''}
      onBlur={handleBlur}
      onChange={handleChange}
      hasError={shouldDisplayError}
      errMsg={errorMessage}
      disabled={disabled}
      autoComplete="off"
      {...restProps}
    />
  );
};

InputFormik.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.oneOf(Object.values(InputSizes)),
  label: PropTypes.node,
  formik: FormikPropTypes.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  valueFormatter: PropTypes.func,
  handleExternalChange: PropTypes.bool,
  hidden: PropTypes.bool,
};

export default InputFormik;
